import FileInfo from '@/types/fileInfo';

import FileUploadChip from '../../ui/chip/FileUploadChip';

type Props = {
  fileInfos?: FileInfo[];
};

/**
 * 첨부파일 컴포넌트
 */
export default function BoardDetailAttachmentFile({ fileInfos }: Props) {
  return (
    <dl className="flex items-center gap-[24px] min-h-[72px] py-[6px] px-[24px] border-b border-b-apps-coreProductDivider">
      <dt className="flex shrink-0 w-[50px] text-[14px] font-normal leading-[150%] text-apps-coreGrayBlack">
        첨부파일
      </dt>
      <dd className="flex flex-wrap grow min-w-0 items-center gap-[6px] text-apps-coreGrayBlack">
        {fileInfos?.map((fileInfo, index) => (
          <FileUploadChip
            key={index}
            file={fileInfo}
            color="gray"
            variant="fill"
            size="sm"
          />
        ))}
      </dd>
    </dl>
  );
}
